import React from 'react';

import { TypeButton } from '../../utils/button';
import { CheckSVG } from '../../utils/svgs';

const SendReportStatusStage = ({ onClose }: { onClose: () => void }) => (
	<div className='f-column-33 animate-fade-in-up align-items-center text-center'>
		<div className='report-success-icon'>
			<CheckSVG
				color='var(--success-500)'
				width='32'
				height='32'
			/>
		</div>
		<div className='f-column-11 align-items-center'>
			<h4 className='m-0'>Issue Reported Successfully</h4>
			<p className='color-label text-little m-0'>
				Your report has been submitted. You&apos;ll be notified once it&apos;s reviewed.
			</p>
		</div>
		<TypeButton
			title='Done'
			buttonSize='small'
			className='w-100'
			onClick={onClose}
		/>
	</div>
);

export default SendReportStatusStage;
